
<div style="height: calc(100vh - 48px); width: 100%;">
  <div id="fileviewer"></div>
</div>
